import React from 'react';
export function StatsBar() {
  const stats = ['2.3M+ emails analyzed', '47% avg open rate increase', '500+ brands optimized', '$12M+ revenue impact'];
  return <div className="bg-gray-900 py-4 overflow-hidden" data-id="element-189">
      <div className="relative flex overflow-x-hidden" data-id="element-190">
        <div className="animate-marquee whitespace-nowrap flex space-x-12 px-4" data-id="element-191">
          {/* Duplicate for infinite scroll effect */}
          {[...stats, ...stats, ...stats].map((stat, index) => <div key={index} className="flex items-center space-x-2 text-gray-100 font-medium" data-id="element-192">
              <span className="h-1.5 w-1.5 rounded-full bg-success" data-id="element-193"></span>
              <span data-id="element-194">{stat}</span>
            </div>)}
        </div>
      </div>
    </div>;
}